<template>
  <div class="button-view">
    <div class="button-view-container" v-if="isFirstQuestion">
      <round-button
        :style="{ opacity: `${needShowQueryList ? 1 : 0}` }"
        class="two-button"
        color="white"
        title="返回"
        @onClick="onBackClick"
      ></round-button>
      <round-button
        class="two-button"
        color="red"
        title="下一题"
        @onClick="onNextClick"
      ></round-button>
    </div>
    <div class="button-view-container" v-else-if="isLastQuestion">
      <round-button
        class="two-button"
        color="white"
        title="上一题"
        @onClick="onLastClick"
      ></round-button>
      <round-button
        class="two-button"
        color="red"
        title="继续"
        @onClick="onSubmitClick"
      ></round-button>
    </div>
    <div class="button-view-container" v-else>
      <round-button
        class="two-button"
        color="white"
        title="上一题"
        @onClick="onLastClick"
      ></round-button>
      <round-button
        class="two-button"
        color="red"
        title="下一题"
        @onClick="onNextClick"
      ></round-button>
    </div>
  </div>
</template>

<script>
import RoundButton from '@c/common/round-button.vue'
export default {
  components: {
    RoundButton
  },

  props: {
    currentQuestionIndex: Number,
    questionArray: Array
  },

  computed: {
    needShowQueryList () {
      return this.$store.state.configurationModel.needShowQueryList
    },

    isFirstQuestion () {
      return this.currentQuestionIndex == 0
    },
    isLastQuestion () {
      return this.currentQuestionIndex == this.questionArray.length - 1
    }
  },

  methods: {
    onBackClick () {
      this.$emit('onBackClick')
    },

    onNextClick () {
      this.$emit('onNextClick')
    },

    onLastClick () {
      this.$emit('onLastClick')
    },

    onSubmitClick () {
      this.$emit('onSubmitClick')
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";
.button-view {
  width: 100%;
  height: 131px;
  box-sizing: border-box;
  padding: 0px 17px;
  display: flex;
  align-items: center;

  &-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}

.one-button {
  width: 100%;
}

.two-button {
  width: 165px;
}
</style>
